export default "__VITE_ASSET__DSX8tCz5__"